module.exports = __webpack_public_path__ + "static/media/focusgroup.938c4497.pdf";